export default __webpack_public_path__ + "static/media/stopwatch.fe20974d.png";